



















































































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Social extends Vue {
  private win = window;
  private base = window.location;
}
